export default {
  path: '/wecode/enterprise-detail',
  auth: false,
  preload: false,
  key: 'new-hardware-detail',
  component: () => import('./index')
};
